module.exports = __webpack_public_path__ + "img/mosque.4bc3ae66.png";